// todo: is this better lifted to top-level config

const clientId = process.env.REACT_APP_API_CLIENT_ID || "";

const _ = {
  apiClientId: clientId,
  authority:
    process.env.REACT_APP_AD_AUTHORITY ||
    "https://login.microsoftonline.com/officequal.onmicrosoft.com/",
  graphScopes: ["user.read", `api://${clientId}/access_as_user`],
};

export default _;
